import React from "react";

function Canvas_Text_Alignment() {
  return (
    <div>
      <h1>Canvas_Text_Alignment Component</h1>
      <p>This is the Canvas Text Alignment tutorial page content.</p>
    </div>
  );
}

export default Canvas_Text_Alignment;
